module.exports = __webpack_public_path__ + "img/数据标准(2)@2x.3abd0ff5.png";